import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { RecommendationsContext } from '..';

type SearchNoResultType = {
  searchTerm: string;
  spellCheck?: string[];
};

const SearchNoResult = (data: SearchNoResultType) => {
  const { searchTerm, spellCheck } = data;
  const t = useTranslations();
  const router = useRouter();
  const { recentSearches } = useContext(RecommendationsContext);

  const openSearchPage = (searchTerm: string) => {
    const query = {
      searchTerm: searchTerm?.toLocaleLowerCase(),
    };
    const url = new URL(window.location.href);
    url.pathname = '/search';
    url.search = new URLSearchParams(query).toString();
    router.push(url);
  };

  return (
    <div className="mt-5 mb-18 flex w-full flex-col gap-10">
      <div className="body-1 text-black/40">
        {t('search.$noresultsearchterm', {
          searchTerm,
        })}
      </div>
      {spellCheck && spellCheck.length > 0 && (
        <div>
          {spellCheck.map((word) => (
            <button key={word} onClick={() => openSearchPage(word)} className="cursor-pointer">
              <span className="font-bold lowercase">{word}</span>
            </button>
          ))}
        </div>
      )}
      {recentSearches && recentSearches.length > 0 && (
        <>
          <div className="body-1 mt-5 text-black/40">{t('search.$previoussearches')}</div>
          <div className="flex flex-col items-start gap-3">
            {recentSearches.map((word) => (
              <button key={word} onClick={() => openSearchPage(word)} className="btn lowercase underline">
                {word}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchNoResult;
